import {primaryColor, sidebarColor} from "../../../nextjs-material-kit.js";
import {buttonOverride} from "../forumsStyle.js";

const lightGrey = "#D2D2D2";
const basicTextColor = "#3c4858";
const white = "#FFFFFF"

const productStyle = (theme) => ({
  homeSearchButton: {
    fontSize: "15px",
    marginTop: "0",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#8665A3",
    marginBottom: "0px",
    lineHeight: "16px",
    display: "flex",
    boxShadow: "none",
    padding: "7.5px 49px",
    "&:hover": {
      backgroundColor: "#704d8d",
    },
  },
  paddingZero: {
    padding: "0 !important",
  },
  readMore: {
    "@media (max-width: 768px)": {
      display: "flex",
    },
  },
  section: {
    padding: "0 0",
    textAlign: "center",
    marginBottom: "2rem",
  },
  jobSection: {
    backgroundColor: "#fff",
    position: "relative",
    borderCollapse: "collapse",
    border: `1px solid ${sidebarColor}`,
    marginTop: "-1px",
  },
  jobCardPlain: {
    borderRadius: "0px",
    boxShadow: "none",
    color: "#095a70",
    paddingBottom: "18px",
  },
  jobCard: {
    borderRadius: "0px",
    color: "#095a70",
    paddingBottom: "20px",
    boxShadow: "none",

    a: {
      textDecoration: "none",
    },

    "> *:last-child": {
      borderBottom: `1px solid ${sidebarColor}`,
    }
  },
  lightGreen: {
    backgroundColor: "#eaf6fe",
  },
  lightGrey: {
    backgroundColor: "#f9f7fa",
  },
  blue: {
    backgroundColor: "#7db2e1",
  },
  purple: {
    backgroundColor: "#683f8c",
  },
  max_width: {
    maxWidth: "60%",
    position: "absolute",
    top: "0",
    left: "50%",
    transform: "translate(-25%, -105px)",
  },
  title: {
    textAlign: "left",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
  },
  container: {
  },
  description: {
    color: "#999",
  },
  customHeading: {
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    color: "#095a70",
    fontSize: "40px",
    marginTop: "0",
  },
  smallerHeading: {
    fontSize: "30px",
  },
  logoContainer: {
    border: "1px solid " + sidebarColor,
    borderBottom: "none",
    padding: "10px",
    background: '#eaf6fe',
    height: "150px",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    img: {
      maxHeight: "100%",
      maxWidth: "100%",
    }
  },
  logoContainerPerJob: {
    border: '0',
    position: 'relative',
  },
  cardFooter: {
    padding: '10px 30px',
  },
  imgFluid: {
    alignSelf: "center",
  },
  primaryColor: {
    backgroundColor: "#095a70",
    textTransform: "capitalize",
    fontFamily: "var(--font-brandon-grotesque)",
    fontSize: "17px",
  },
  lightColor: {
    backgroundColor: "#7db2e1",
    textTransform: "capitalize",
    fontFamily: "var(--font-brandon-grotesque)",
    fontSize: "17px",
  },
  sideIcon: {
    width: "auto",
    height: "auto",
    position: "absolute",
    minWidth: "auto",
    marginTop: "0",
    minHeight: "auto",
    lineHeight: 3,
    paddingTop: "0px",
    paddingLeft: "4px",
    marginBottom: "0",
    paddingRight: "0",
    paddingBottom: "0",
    zIndex: 1,
  },
  sideLeftIcon: {
    right: "5px",
    top: "10px",
  },
  sideRightIcon: {
    right: "5px",
    bottom: "10px",
  },
  employerJobsHeading: {
    fontSize: "20px",
    color: basicTextColor,
    fontWeight: "bold",
  },
  employerJobsContainer: {
    padding: "20px",
    border: "1px solid " + lightGrey,
    borderRadius: "20px",
  },
  rounded: {
    borderRadius: "20px",
  },
  roundedTop: {
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
  },
  roundedBottom: {
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
  },
  marginBottom: {
    marginBottom: "20px",
  },
  largePillButton: {
    fontSize: "1.0em !important",
    padding: "15px 40px !important",
    borderRadius: "50px",
    width: "max-content",
    margin: "10px auto",
  },
  darkButton: {
    ...buttonOverride,
    border: `1px solid ${primaryColor}`,
    backgroundColor: primaryColor,
    color: `${white} !important`,
    "&:hover": {
      backgroundColor: primaryColor,
      color: `${white} !important`,
    },
    "&:focus": {
      backgroundColor: primaryColor,
      color: `${white} !important`,
    },
    "&:active": {
      backgroundColor: primaryColor,
      color: `${white} !important`,
    },
    "&:clicked": {
      backgroundColor: primaryColor,
      color: `${white} !important`,
    }
  },
});

export default productStyle;
